"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _omitBy2 = _interopRequireDefault(require("lodash/omitBy"));

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _yn = _interopRequireDefault(require("yn"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * `SentryClient`.
 */
var SentryClient = /*#__PURE__*/function () {
  function SentryClient() {
    var _this = this;

    _classCallCheck(this, SentryClient);

    _defineProperty(this, "dsnExists", false);

    _defineProperty(this, "isReportDialogEnabled", false);

    _defineProperty(this, "isReportDialogToShow", function () {
      return _this.dsnExists && _this.isReportDialogEnabled;
    });
  }

  _createClass(SentryClient, [{
    key: "init",
    value:
    /**
     * Init.
     *
     * Initializes the `SentryClient`.
     */
    function init(sentryOptions) {
      var dsn = sentryOptions.dsn,
          options = sentryOptions.options,
          packageJson = sentryOptions.packageJson,
          _sentryOptions$report = sentryOptions.reportDialog,
          reportDialog = _sentryOptions$report === void 0 ? false : _sentryOptions$report;

      if ((0, _isNil2["default"])(dsn)) {
        return;
      }

      var _options$extras = options.extras,
          extras = _options$extras === void 0 ? {} : _options$extras,
          _options$init = options.init,
          init = _options$init === void 0 ? {} : _options$init,
          _options$tags = options.tags,
          tags = _options$tags === void 0 ? {} : _options$tags;
      this.dsnExists = true;
      this.isReportDialogEnabled = (0, _yn["default"])(reportDialog);
      this.initClient({
        dsn: dsn,
        init: init
      });
      this.configureScope({
        extras: extras,
        packageJson: packageJson,
        tags: tags
      });
    }
    /**
     * Init client.
     *
     * Initializes the `Sentry` client with the given `dsn` and `init` options.
     */

  }, {
    key: "initClient",
    value: function initClient(_ref) {
      var dsn = _ref.dsn,
          init = _ref.init;
      Sentry.init(_objectSpread({
        dsn: dsn,
        ignoreErrors: [// Random plugins/extensions
        'top.GLOBALS', // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
        'originalCreateNotification', 'canvas.contentDocument', 'MyApp_RemoveAllHighlights', 'http://tt.epicplay.com', 'Can\'t find variable: ZiteReader', 'jigsaw is not defined', 'ComboSearch is not defined', 'http://loading.retry.widdit.com/', 'atomicFindClose', // Facebook borked
        'fb_xd_fragment', // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
        // reduce this. (thanks @acdha)
        // See http://stackoverflow.com/questions/4113268
        'bmi_SafeAddOnload', 'EBCallBackMessageReceived', // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
        'conduitPage', // Errors we can ignore
        /ChunkLoadError/, /Network Error/, /SecurityError/, /vid_mate_check is not defined/],
        ignoreUrls: [// Chrome extensions
        /chrome-extension:\/\//i, /extensions\//i, /^chrome:\/\//i, // Firefox extensions
        /^resource:\/\//i, // Ignore Google flakiness
        /\/(gtm|ga|analytics)\.js/i, // Other plugins
        /127\.0\.0\.1:4001\/isrunning/i, /webappstoolbarba\.texthelp\.com\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i]
      }, init));
    }
    /**
     * Configure scope.
     *
     * Configures the global scope for the client events according to the given
     * `extras` and `tags` options.
     */

  }, {
    key: "configureScope",
    value: function configureScope(scopeOptions) {
      var extras = scopeOptions.extras,
          packageJson = scopeOptions.packageJson,
          tags = scopeOptions.tags;
      Sentry.setTags(_objectSpread({
        name: "".concat(packageJson === null || packageJson === void 0 ? void 0 : packageJson.name, ":client"),
        version: packageJson === null || packageJson === void 0 ? void 0 : packageJson.version
      }, tags));
      Sentry.setExtras(_objectSpread({
        dependencies: packageJson === null || packageJson === void 0 ? void 0 : packageJson.dependencies
      }, extras));
    }
    /**
     * Is report dialog to show.
     *
     * Informs if the report dialog feature is enabled or disabled.
     */

  }, {
    key: "showReportDialog",
    value:
    /**
     * Show report dialog.
     *
     * Shows the event report dialog through `Sentry`.
     */
    function showReportDialog(_ref2) {
      var sentryEventId = _ref2.sentryEventId;
      Sentry.showReportDialog({
        eventId: sentryEventId
      });
    }
    /**
     * Capture exception.
     *
     * Captures exception with specific event scope.
     */

  }, {
    key: "captureException",
    value: function captureException(captureExceptionOptions) {
      var error = captureExceptionOptions.error,
          errorInfo = captureExceptionOptions.errorInfo,
          _captureExceptionOpti = captureExceptionOptions.severity,
          severity = _captureExceptionOpti === void 0 ? 'error' : _captureExceptionOpti,
          user = captureExceptionOptions.user;

      if (!this.dsnExists) {
        return;
      }

      var eventId = Sentry.withScope(function (scope) {
        scope.setLevel(severity);
        scope.setUser((0, _omitBy2["default"])(user, _isUndefined2["default"]));
        scope.setExtras(errorInfo);
        var eventId = Sentry.captureException(error);
        return eventId;
      });
      return eventId;
    }
  }]);

  return SentryClient;
}();
/**
 * Export `sentryClient`.
 */


var _default = new SentryClient();

exports["default"] = _default;